import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react'
import { demoPagesMenu } from '../menu'
import { getJwtToken, setJwtToken, getUserData, StoredUserData } from '../utils/localStorage'
import { clearAuthSession, isJwtExpired, logoutAndRedirectToLogin } from '../utils/authSession'

export interface IAuthContextProps {
	user: string
	setUser: (user: string) => void
	userData: StoredUserData | null
	setUserData: (userData: StoredUserData | null) => void
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps)

interface IAuthContextProviderProps {
	children: ReactNode
}

export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>(() => {
		const t = getJwtToken()
		if (t && isJwtExpired(t)) {
			clearAuthSession()
			return ''
		}
		return t || ''
	})
	const [userData, setUserData] = useState<StoredUserData | null>(getUserData())
	const [isLoggedIn, setIsLoggedIn] = useState(false)

	useEffect(() => {
		if ((user === '' || user.length <= 0) && !window.location.pathname.includes(`/${demoPagesMenu.login.path}`)) {
			logoutAndRedirectToLogin()
		} else {
			setJwtToken(user)
			setIsLoggedIn(true)
		}
	}, [user])

	const value = useMemo(
		() => ({
			user,
			setUser,
			userData,
			setUserData,
		}),
		[user, userData]
	)

	return isLoggedIn ? <AuthContext.Provider value={value}>{children}</AuthContext.Provider> : <div></div>
}

export default AuthContext
